import axios from "axios";
import { logoutUser } from "../utilities/auth";
import { API_BASE_URL, SCRAPING_API_BASE_URL } from "../utilities/constants";


// Create an Axios instance for main API
const api = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		Accept: "application/json",
	},
});

// Create an Axios instance for scraping service
const scrapingApi = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		Accept: "application/json",
	},
});

// Attach token to every request
api.interceptors.request.use((config) => {
	const token = localStorage.getItem("token");
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
		config.headers["X-JWT-Assertion"] = `${token}`;
	} else {
		config.headers["X-JWT-Assertion"] = "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjAsInVzZXJOYW1lIjoiU3lzdGVtLVRva2VuIiwiYXV0aG9yaXRpZXMiOlswXSwiaXNzIjoib2N0b3BpLWxhYnMuY29tIiwiZXhwIjoxNzY2NTUzOTM3LCJpYXQiOjE3MzUwMTc5Mzd9.8QDXGUGMIFQsjGi4yFCYr9F8xZRjFXUB8GVIhzVBvgs";
	}
	return config;
});

// Auto logout on 401/403 errors
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (
			error.response &&
			(error.response.status === 401 || error.response.status === 403)
		) {
			logoutUser();
		}
		return Promise.reject(error);
	}
);

// Attach token to scraping API requests
scrapingApi.interceptors.request.use((config) => {
	const token = localStorage.getItem("token");
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
		config.headers["X-JWT-Assertion"] = `${token}`;
	} else {
		config.headers["X-JWT-Assertion"] = "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjAsInVzZXJOYW1lIjoiU3lzdGVtLVRva2VuIiwiYXV0aG9yaXRpZXMiOlswXSwiaXNzIjoib2N0b3BpLWxhYnMuY29tIiwiZXhwIjoxNzY2NTUzOTM3LCJpYXQiOjE3MzUwMTc5Mzd9.8QDXGUGMIFQsjGi4yFCYr9F8xZRjFXUB8GVIhzVBvgs";
	}
	return config;
});

// Auto logout on 401/403 errors for scraping API
scrapingApi.interceptors.response.use(
	(response) => response,
	(error) => {
		if (
			error.response &&
			(error.response.status === 401 || error.response.status === 403)
		) {
			logoutUser();
		}
		return Promise.reject(error);
	}
);

export const scrapeService = {
	startJob: (url, scrapeMode = 'FAST') => scrapingApi.post('/api/1.0.0/scrape/start', { url, scrapeMode }),
	getJobStatus: (jobId) => scrapingApi.get(`/api/1.0.0/scrape/job/${jobId}`),
	getAllJobs: () => scrapingApi.get('/api/1.0.0/scrape/jobs'),
	getJobsByStatus: (status) => scrapingApi.get(`/api/1.0.0/scrape/jobs/status/${status}`),
};

export const productService = {
	getAllProducts: () => scrapingApi.get('/api/1.0.0/scrapping/products'),
	getProductById: (id) => scrapingApi.get(`/api/1.0.0/scrapping/products/${id}`),
	getProductsByCategory: (category) => scrapingApi.get(`/api/1.0.0/scrapping/products/category/${category}`),
	getProductsByBrand: (brand) => scrapingApi.get(`/api/1.0.0/scrapping/products/brand/${brand}`),
	getRecentProducts: () => scrapingApi.get('/api/1.0.0/scrapping/products/recent'),
	getInStockProducts: () => scrapingApi.get('/api/1.0.0/scrapping/products/in-stock'),
	getProductsByVendor: (vendor, page = 0, size = 20, sortBy = 'scrapedAt', sortDir = 'DESC') =>
		scrapingApi.get(`/api/1.0.0/scrapping/products/vendor/${vendor}`, {
			params: { page, size, sortBy, sortDir }
		}),
	getAllVendors: () => scrapingApi.get('/api/1.0.0/scrapping/products/vendors'),
	getNormalizedProduct: (productId) => scrapingApi.get(`/api/1.0.0/scrapping/products/normalised-product/productId/${productId}`),
	searchPartnerProducts: (params) => scrapingApi.get('/api/1.0.0/partner-product/search', { params }),
};

export default api;
